import { Label, Text } from "@fluentui/react";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";
import { INewManagedTenantState } from "../../types/INewManagedTenantState";
import styled from "styled-components";

interface IFinishPage {
  wizardState: INewManagedTenantState;
  isPrincipal: boolean;
  appName: string;
}

const FinishPrincipalPage: FC<IFinishPage> = ({ wizardState, appName, isPrincipal }) => {
  const { tenant, predefinedJobs } = wizardState;

  return (
    <>
      <StyledText className="sub-text">
        <FormattedMessage
          id="new-managed-tenant-wizard.finish.principal.subtitle"
          // tslint:disable-next-line: max-line-length
          defaultMessage="This tenant will now appear in your list of managed tenants."
        />
      </StyledText>

      <Label>
        <FormattedMessage
          id="new-managed-tenant-wizard.finish.principal.tenant-settings"
          defaultMessage="Tenant settings:"
        />
      </Label>
      <Text block>
        <FormattedMessage
          id="new-managed-tenant-wizard.finish.principal.tenant-name"
          defaultMessage="Name: {tenant}"
          values={{ tenant: tenant?.name || "?" }}
        />
      </Text>
      {isPrincipal && (
        <Text block>
          <FormattedMessage
            id="new-managed-tenant-wizard.finish.principal.account-name"
            defaultMessage="Entra application account: {account}"
            values={{ account: appName || "?" }}
          />
        </Text>
      )}
      <br />
      <Label>
        <FormattedMessage
          id="new-managed-tenant-wizard.finish.principal.configured-jobs-title"
          defaultMessage="Configured jobs:"
        />
      </Label>
      {predefinedJobs?.map((j, i) => (
        <Text key={i} block>
          {j.name}
        </Text>
      ))}
      <br />
    </>
  );
};

const StyledText = styled(Text)`
  font-weight: 600;

  &.sub-text {
    margin-bottom: 20px;
  }
`;

export default FinishPrincipalPage;
